import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addNotification, setNotifications } from '../../store/notificationsSlice';
import axiosClient from '../../axios-client';
import echo from '../../js/echo';
import NotificationsDropdown from './NotificationsDropdown';

export default function BellIcon({ userId }) {
  const dispatch = useDispatch();
  const unreadCount = useSelector((state) => state.notifications.unreadCount);
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  // Hydrate unread count on mount
  useEffect(() => {
    axiosClient.get('/notifications')
      .then(({ data }) => dispatch(setNotifications(data)))
      .catch(() => {});
  }, [dispatch]);

  // Subscribe to real-time channels (only if Echo is available)
  useEffect(() => {
    if (!userId || !echo) return;

    const globalChannel = echo.channel('notifications');
    globalChannel.listen('.notification.sent', (data) => {
      dispatch(addNotification(data));
    });

    const privateChannel = echo.private(`user.${userId}`);
    privateChannel.listen('.notification.sent', (data) => {
      dispatch(addNotification(data));
    });

    return () => {
      echo.leaveChannel('notifications');
      echo.leaveChannel(`private-user.${userId}`);
    };
  }, [userId, dispatch]);

  return (
    <div className="bell-icon-wrapper" ref={wrapperRef}>
      <button className="bell-btn" onClick={() => setOpen((prev) => !prev)}>
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" viewBox="0 0 16 16">
          <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z"/>
        </svg>
        {unreadCount > 0 && (
          <span className="bell-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
        )}
      </button>

      {open && <NotificationsDropdown />}
    </div>
  );
}